import { createFileRoute } from '@tanstack/react-router';
import { AccessScreen } from '../features/access/AccessScreen';
import { PartnerTeamScreen } from '../features/access/PartnerTeamScreen';
import { isMspStaff, useSession } from '../auth/session';

/**
 * Platform-wide access for MSP staff, or partner team self-serve when the session is partner-scoped
 * (real ResellerAdmin or view-as).
 */
export const Route = createFileRoute('/access')({
  component: AccessRoute,
});

function AccessRoute() {
  const { data: session } = useSession();
  const partnerScoped =
    Boolean(session?.viewAsPartner) || (session?.partnerBooks?.length ?? 0) > 0;

  // View-as clears MSP grants from the session payload, so partnerScoped alone is enough while
  // viewing as. Real MSP staff (not viewing as) keep the platform screen.
  if (partnerScoped && !isMspStaff(session)) {
    return <PartnerTeamScreen />;
  }

  return <AccessScreen />;
}
